import { t } from 'util/i18n';

export const lineData = [
	{ id: 0, name: '文山內湖' },
	{ id: 1, name: '板橋南港' },
	{ id: 2, name: '淡水信義' },
	{ id: 3, name: '中和新蘆' },
	{ id: 4, name: '松山新店' },
];

export const stationData = [
	{
		id: 1,
		name: '南港軟體園區',
		line: '文山內湖',
		near_station: '東湖,南港展覽館',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 2,
		name: '南港展覽館',
		line: '文山內湖,板橋南港',
		near_station: '南港軟體園區,南港',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 3,
		name: '東湖',
		line: '文山內湖',
		near_station: '葫洲,南港軟體園區',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 4,
		name: '葫洲',
		line: '文山內湖',
		near_station: '大湖公園,東湖',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 5,
		name: '大湖公園',
		line: '文山內湖',
		near_station: '內湖,葫洲',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 6,
		name: '內湖',
		line: '文山內湖',
		near_station: '文德,大湖公園',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 7,
		name: '文德',
		line: '文山內湖',
		near_station: '港墘,內湖',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 8,
		name: '港墘',
		line: '文山內湖',
		near_station: '西湖,文德',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 9,
		name: '西湖',
		line: '文山內湖',
		near_station: '劍南路,港墘',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 10,
		name: '劍南路',
		line: '文山內湖',
		near_station: '大直,西湖',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 11,
		name: '大直',
		line: '文山內湖',
		near_station: '松山機場,劍南路',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 12,
		name: '松山機場',
		line: '文山內湖',
		near_station: '中山國中,大直',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 13,
		name: '中山國中',
		line: '文山內湖',
		near_station: '南京復興,松山機場',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 14,
		name: '南京復興',
		line: '文山內湖,松山新店',
		near_station: '松江南京,中山國中,台北小巨蛋,忠孝復興',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 15,
		name: '忠孝復興',
		line: '文山內湖,板橋南港',
		near_station: '忠孝新生,南京復興,忠孝敦化,大安',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 16,
		name: '大安',
		line: '文山內湖,淡水信義',
		near_station: '大安森林公園,忠孝復興,信義安和,科技大樓',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 17,
		name: '科技大樓',
		line: '文山內湖',
		near_station: '大安,六張犁',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 18,
		name: '六張犁',
		line: '文山內湖',
		near_station: '科技大樓,麟光',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 19,
		name: '麟光',
		line: '文山內湖',
		near_station: '六張犁,辛亥',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 20,
		name: '辛亥',
		line: '文山內湖',
		near_station: '麟光,萬芳醫院',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 21,
		name: '萬芳醫院',
		line: '文山內湖',
		near_station: '辛亥,萬芳社區',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 22,
		name: '萬芳社區',
		line: '文山內湖',
		near_station: '萬芳醫院,木柵',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 23,
		name: '木柵',
		line: '文山內湖',
		near_station: '萬芳社區,動物園',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 24,
		name: '動物園',
		line: '文山內湖',
		near_station: '木柵',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 25,
		name: '淡水',
		line: '淡水信義',
		near_station: '紅樹林',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 26,
		name: '紅樹林',
		line: '淡水信義',
		near_station: '淡水,竹圍',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 27,
		name: '竹圍',
		line: '淡水信義',
		near_station: '紅樹林,關渡',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 28,
		name: '關渡',
		line: '淡水信義',
		near_station: '竹圍,忠義',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 29,
		name: '忠義',
		line: '淡水信義',
		near_station: '關渡,復興崗',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 30,
		name: '復興崗',
		line: '淡水信義',
		near_station: '忠義,北投',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 31,
		name: '北投',
		line: '淡水信義',
		near_station: '復興崗,新北投,奇岩',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 32,
		name: '新北投',
		line: '淡水信義',
		near_station: '北投',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 33,
		name: '奇岩',
		line: '淡水信義',
		near_station: '北投,唭哩岸',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 34,
		name: '唭哩岸',
		line: '淡水信義',
		near_station: '奇岩,石牌',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 35,
		name: '石牌',
		line: '淡水信義',
		near_station: '唭哩岸,明德',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 36,
		name: '明德',
		line: '淡水信義',
		near_station: '石牌,芝山',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 37,
		name: '芝山',
		line: '淡水信義',
		near_station: '明德,士林',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 38,
		name: '士林',
		line: '淡水信義',
		near_station: '芝山,劍潭',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 39,
		name: '劍潭',
		line: '淡水信義',
		near_station: '士林,圓山',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 40,
		name: '圓山',
		line: '淡水信義',
		near_station: '劍潭,民權西路',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 41,
		name: '民權西路',
		line: '淡水信義,中和新蘆',
		near_station: '圓山,中山國小,雙連,大橋頭',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 42,
		name: '雙連',
		line: '淡水信義',
		near_station: '民權西路,中山',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 43,
		name: '中山',
		line: '淡水信義,松山新店',
		near_station: '雙連,松江南京,台北車站,北門',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 44,
		name: '台北車站',
		line: '淡水信義,板橋南港',
		near_station: '中山,善導寺,台大醫院,西門',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 45,
		name: '台大醫院',
		line: '淡水信義',
		near_station: '台北車站,中正紀念堂',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 46,
		name: '中正紀念堂',
		line: '淡水信義,松山新店',
		near_station: '台大醫院,東門,古亭,小南門',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 47,
		name: '東門',
		line: '淡水信義,中和新蘆',
		near_station: '忠孝新生,大安森林公園,古亭,中正紀念堂',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 48,
		name: '大安森林公園',
		line: '淡水信義',
		near_station: '大安,東門',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 49,
		name: '信義安和',
		line: '淡水信義',
		near_station: '大安,台北101/世貿',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 50,
		name: '台北101/世貿',
		line: '淡水信義',
		near_station: '信義安和,象山',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 51,
		name: '象山',
		line: '淡水信義',
		near_station: '台北101/世貿',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 52,
		name: '小南門',
		line: '松山新店',
		near_station: '西門,中正紀念堂',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 53,
		name: '古亭',
		line: '松山新店,中和新蘆',
		near_station: '東門,台電大樓,頂溪,中正紀念堂',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 54,
		name: '台電大樓',
		line: '松山新店',
		near_station: '古亭,公館',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 55,
		name: '公館',
		line: '松山新店',
		near_station: '台電大樓,萬隆',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 56,
		name: '萬隆',
		line: '松山新店',
		near_station: '公館,景美',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 57,
		name: '景美',
		line: '松山新店',
		near_station: '萬隆,大坪林',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 58,
		name: '大坪林',
		line: '松山新店',
		near_station: '景美,七張',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 59,
		name: '七張',
		line: '松山新店',
		near_station: '大坪林,小碧潭,新店區公所',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 60,
		name: '小碧潭',
		line: '松山新店',
		near_station: '七張',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 61,
		name: '新店區公所',
		line: '松山新店',
		near_station: '小碧潭,新店',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 62,
		name: '新店',
		line: '松山新店',
		near_station: '新店區公所',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 63,
		name: '南勢角',
		line: '中和新蘆',
		near_station: '景安',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 64,
		name: '景安',
		line: '中和新蘆',
		near_station: '南勢角,永安市場',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 65,
		name: '永安市場',
		line: '中和新蘆',
		near_station: '景安,頂溪',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 66,
		name: '頂溪',
		line: '中和新蘆',
		near_station: '永安市場,古亭',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 67,
		name: '忠孝新生',
		line: '中和新蘆,板橋南港',
		near_station: '松江南京,忠孝復興,東門,善導寺',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 68,
		name: '松江南京',
		line: '中和新蘆',
		near_station: '行天宮,南京復興,忠孝新生,中山',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 69,
		name: '行天宮',
		line: '中和新蘆',
		near_station: '松江南京,中山國小',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 70,
		name: '中山國小',
		line: '中和新蘆',
		near_station: '行天宮,民權西路',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 71,
		name: '大橋頭',
		line: '中和新蘆',
		near_station: '民權西路,三重國小,台北橋',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 72,
		name: '三重國小',
		line: '中和新蘆',
		near_station: '三和國中,大橋頭',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 73,
		name: '三和國中',
		line: '中和新蘆',
		near_station: '三重國小,徐匯中學',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 74,
		name: '徐匯中學',
		line: '中和新蘆',
		near_station: '三和國中,三民高中',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 75,
		name: '三民高中',
		line: '中和新蘆',
		near_station: '徐匯中學,蘆洲',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 76,
		name: '蘆洲',
		line: '中和新蘆',
		near_station: '三民高中',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 77,
		name: '台北橋',
		line: '中和新蘆',
		near_station: '大橋頭,菜寮',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 78,
		name: '菜寮',
		line: '中和新蘆',
		near_station: '台北橋,三重',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 79,
		name: '三重',
		line: '中和新蘆',
		near_station: '菜寮,先嗇宮',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 80,
		name: '先嗇宮',
		line: '中和新蘆',
		near_station: '三重,頭前庄',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 81,
		name: '頭前庄',
		line: '中和新蘆',
		near_station: '先嗇宮,新莊',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 82,
		name: '新莊',
		line: '中和新蘆',
		near_station: '頭前庄,輔大',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 83,
		name: '輔大',
		line: '中和新蘆',
		near_station: '新莊,丹鳳',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 84,
		name: '丹鳳',
		line: '中和新蘆',
		near_station: '輔大,迴龍',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 85,
		name: '迴龍',
		line: '中和新蘆',
		near_station: '丹鳳',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 86,
		name: '南港',
		line: '板橋南港',
		near_station: '南港展覽館,昆陽',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 87,
		name: '昆陽',
		line: '板橋南港',
		near_station: '南港,後山埤',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 88,
		name: '後山埤',
		line: '板橋南港',
		near_station: '昆陽,永春',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 89,
		name: '永春',
		line: '板橋南港',
		near_station: '後山埤,市政府',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 90,
		name: '市政府',
		line: '板橋南港',
		near_station: '永春,國父紀念館',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 91,
		name: '國父紀念館',
		line: '板橋南港',
		near_station: '市政府,忠孝敦化',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 92,
		name: '忠孝敦化',
		line: '板橋南港',
		near_station: '國父紀念館,忠孝復興',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 93,
		name: '善導寺',
		line: '板橋南港',
		near_station: '忠孝新生,台北車站',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 94,
		name: '西門',
		line: '板橋南港',
		near_station: '北門,台北車站,小南門,龍山寺',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 95,
		name: '龍山寺',
		line: '板橋南港',
		near_station: '西門,江子翠',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 96,
		name: '江子翠',
		line: '板橋南港',
		near_station: '龍山寺,新埔',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 97,
		name: '新埔',
		line: '板橋南港',
		near_station: '江子翠,板橋',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 98,
		name: '板橋',
		line: '板橋南港',
		near_station: '新埔,府中',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 99,
		name: '府中',
		line: '板橋南港',
		near_station: '板橋,亞東醫院',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 100,
		name: '亞東醫院',
		line: '板橋南港',
		near_station: '府中,海山',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 101,
		name: '海山',
		line: '板橋南港',
		near_station: '亞東醫院,土城',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 102,
		name: '土城',
		line: '板橋南港',
		near_station: '海山,永寧',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 103,
		name: '永寧',
		line: '板橋南港',
		near_station: '土城,頂埔',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
	{
		id: 104,
		name: '頂埔',
		line: '板橋南港',
		near_station: '永寧',
		created_at: '2018-06-26 14:41:43',
		updated_at: '2018-06-26 14:41:43',
	},
];

export default stationData;

export const organizeMrtData = mrtData => {
	const mrtLineList = [];
	const mrtLineData = {};
	const mrtStationData = {};

	mrtLineList.push(0);

	mrtLineData[0] = { value: 0, label: t('roomFilter:all'), name: '全部', stations: [] };

	mrtData.forEach(mrt => {
		const lines = mrt.line.split(',');

		lines.forEach(line => {
			// organize line data
			let lineId = mrtLineList.find(id => mrtLineData[id].name === line);
			if (!lineId) {
				lineId = mrtLineList.length;

				mrtLineList.push(lineId);
				mrtLineData[lineId] = {
					value: lineId,
					label: t('roomFilter:line', { line }),
					name: line,
					stations: [],
				};
			}

			// organize station data
			mrtLineData[lineId].stations.push(mrt.id);
			// mrtStationList[lineId].push(mrt.id);
			mrtStationData[mrt.id] = {
				value: mrt.id,
				label: t('roomFilter:station', { station: mrt.name }),
				name: mrt.name,
			};
		});
	});

	return { mrtLineList, mrtLineData, mrtStationData };
};



// WEBPACK FOOTER //
// ./src/util/mrt.js